import React, { useMemo } from 'react';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';

const ModelsTable = ({ models, loading, onModelClick, onModelDeleteClick, readOnly }) => {
  const tableRows = useMemo(
    () =>
      models.map((model, i) => (
        <SelectableRow key={i} onClick={() => onModelClick(model)}>
          <Row children={model.name} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onModelDeleteClick(model);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [readOnly, onModelDeleteClick, loading, models, onModelClick],
  );

  return <Table columns={readOnly ? readOnlyColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const readOnlyColumns = [{ name: 'Назва', className: 'w-[100%]' }];

const columns = [
  { name: 'Назва', className: 'w-[95%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default ModelsTable;
